export const enum PeopleSecondaryMenuItems {
  COMPANIES = 'companies',
  PERFORMERS = 'performers'
}
